import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslationService } from 'src/metronic/core/_base/layout';

@Injectable({
  providedIn: 'root'
})
export class ErrorNotifierService {
  constructor(
    private snackBar: MatSnackBar,
    private translateService: TranslationService
  ) { }

  showError(message: string): void {
    this.snackBar.open(message, 'X', {
      panelClass: 'rek-error-snackbar',
      horizontalPosition: 'end',
      verticalPosition: 'top'
    });
  }

  showGenericClientSideError(): void {
    this.showGenericError('SHARED.ERRORS.GENERIC-CLIENT-SIDE-ERROR');
  }

  showGenericServerSideError(): void {
    this.showGenericError('SHARED.ERRORS.GENERIC-SERVER-SIDE-ERROR');
  }

  private showGenericError(errorTranlsateKey: string): void {
    this.translateService.getTranslationFor(errorTranlsateKey)
      .subscribe((translation: string) => this.showError(translation));
  }
}
